// Stub: Content hash resolution is not used on Ethereum Classic
// ECNS will provide its own resolution mechanism when deployed

export function hexToUint8Array(hex: string): Uint8Array {
  if (hex.slice(0, 2) === '0x') {
    hex = hex.slice(2)
  }
  const bytes = new Uint8Array(hex.length / 2)
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16)
  }
  return bytes
}

export default function contenthashToUri(_contenthash: string): string | null {
  // Content hash resolution is not supported on ETC
  console.warn('contenthashToUri is not supported on Ethereum Classic')
  return null
}
